import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { cancelarFilaLayout } from '../functions'
import { useForm } from 'react-hook-form'
import Input from '../../../../components/Input'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup.object().shape({
  numero_nota: yup.string().required('Número da nota obrigatório'),
  identificador: yup.string().required('Identificador obrigatório'),
  sequencia: yup.string().required('Sequência obrigatório'),
  codprod: yup.string().required('Codprod obrigatório'),
  observacao: yup.string().required('Observação obrigatório'),
})

export function CancelarFilaLayout() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { handleSubmit, register, formState } = useForm({
    resolver: yupResolver(schema),
  })

  const toast = useToast({
    position: 'top',
  })

  async function handleCancelarFilaLayout(data) {
    const response = await cancelarFilaLayout({
      numero_nota: data.numero_nota,
      identificador: data.identificador,
      sequencia: data.sequencia,
      codprod: data.codprod,
      observacao: data.observacao,
    })

    console.log(response)

    if (response.success) {
      toast({
        title: 'Sucesso!',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })

      onClose()

      return
    }

    toast({
      title: 'Erro!',
      status: 'error',
      duration: 5000,
      isClosable: true,
    })
  }

  return (
    <>
      <Button onClick={onOpen} variant="outline" maxW="300px" w="100%">
        Cancelar layout da fila
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          as="form"
          onSubmit={handleSubmit(handleCancelarFilaLayout)}
        >
          <ModalHeader>Cancelar layout da fila</ModalHeader>
          <ModalCloseButton />
          <ModalBody
            as="fieldset"
            disabled={formState.isSubmitting}
            display="flex"
            flexDirection="column"
            gridGap="1rem"
          >
            <Input
              placeholder="Digite o número da nota"
              {...register('numero_nota')}
              name="numero_nota"
              label="Número da nota"
              error={formState.errors.numero_nota}
            />
            <Input
              placeholder="Digite o identificador"
              {...register('identificador')}
              name="identificador"
              label="Identificador"
              error={formState.errors.identificador}
            />
            <Input
              placeholder="Digite a sequência"
              {...register('sequencia')}
              name="sequencia"
              label="Sequência"
              error={formState.errors.sequencia}
            />
            <Input
              placeholder="Digite o codprod"
              {...register('codprod')}
              name="codprod"
              label="Codprod"
              error={formState.errors.codprod}
            />
            <Input
              placeholder="Digite a observação"
              {...register('observacao')}
              name="observacao"
              label="Observação"
              error={formState.errors.observacao}
            />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              variant="ghost"
              type="submit"
              isLoading={formState.isSubmitting}
              disabled={formState.isSubmitting}
            >
              Cancelar layout da fila
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
